import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import Select from "react-select";
import AddClip from "./AddClip";
import SearchLocationInput from "./GoogleMapLocation";
import { list as industryList } from "../../../services/industry";
import { list as skillList } from "../../../services/skill";
import { list as jobNicheList } from "../../../services/jobNiche";
import { list as badgeList} from "../../../services/badge";
import { list as rejectedReasons } from "../../../services/rejectedReason";
import { createExternalWriter, saveWriter } from "../../../services/userDatails";
class CreateModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                first_name : "",
                last_name: "",
                email_address: "",
                location: "",
                country_code: "",
                industry: [],
                topic: [],
                skill: [],
                byLine: "",
                twitter: "",
                facebook: "",
                linkedin: "",
                personalWebsite: "",
                user_id: "",
                clips: [],
                verification: false,
                status: "",
                badge: [],
                decline_details: "",
                reason: []
            },
            errors: {},
            industryList: [],
            topicList: [],
            skillList: [],
            loading: false,
            selectedFile: '',
            badgeList: [],
            rejectedReasons: [],
            statusList: [
                { id: 1, value: "applied", name: "Applied", label: "Applied" },
                { id: 2, value: "approved", name: "Approved", label: "Approved" },
                { id: 3, value: "rejected", name: "Declined", label: "Declined" }
            ]
        };
    }

    

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;


        let file = this.state.selectedFile;
        let FileSize = file.size / 1024 / 1024; // in MB
        let FileName = file.name;
        let extensionLists = {}; //Create an object for all extension lists         
        extensionLists.image = ['jpg', 'gif', 'bmp', 'png'];

        if(!fields.first_name){
            formIsValid = false;
            errors.first_name = "The first name field is required.";
        }

        if (!fields.last_name) {
            formIsValid = false;
            errors.last_name = "The last name field is required.";
        }

        // if (!fields.email_address) {
        //     formIsValid = false;
        //     errors.email_address = "The email address field is required.";
        // }

        if (!fields.industry || fields.industry.length == 0) {
            formIsValid = false;
            errors.industry = "The industry field is required.";
        }

        if (file && !this.isImage(FileName)) {
            formIsValid = false;
            errors.writer_image = "Please select a valid image file.";
        }

        if (file && FileSize > 2) {
            formIsValid = false;
            errors.writer_image = "Please select a valid size image file.";
        }

        if (fields.personalWebsite && !this.validURL(fields.personalWebsite)) {
            formIsValid = false;
            errors.personalWebsite = "Please provide valid URL.";
        }

        let clipDetails = this.state.item.clips;
        for(let i=0; i<clipDetails.length; i++) {
            if(!this.validURL(clipDetails[i])) {
                formIsValid = false;
                errors.clips = "Please provide valid ClipURL";
                break;
            }
        }

        this.setState({errors: errors});
        return formIsValid;
    } 

    getExtension(filename) {
        let parts = filename.split('.');
        return parts[parts.length - 1];
    }

    
    isImage(filename) {
        let ext = this.getExtension(filename);
        switch (ext.toLowerCase()) {
            case 'jpg':
            case 'gif':
            case 'bmp':
            case 'png':
                //etc
                return true;
        }
        return false;
    }

    create = e => {
        e.preventDefault();
        const formData = new FormData(e.target);
        if(this.handleValidation()){  
            this.setState({ loading: true });

            if (this.state.selectedFile) {
                formData.append(
                    'image',
                    this.state.selectedFile,
                    this.state.selectedFile.name
                )
            }

            formData.append('first_name', this.state.item.first_name);
            formData.append('last_name', this.state.item.last_name);
            formData.append('email_address', this.state.item.email_address);
            formData.append('location', this.state.item.location);
            formData.append('country_code', this.state.item.country_code);
            formData.append('industry', this.state.item.industry);
            formData.append('topic', this.state.item.topic);
            formData.append('skill', this.state.item.skill);
            formData.append('byLine', this.state.item.byLine);
            formData.append('clips', this.state.item.clips);
            formData.append('personalWebsite', this.state.item.personalWebsite);
            formData.append('user_id', this.state.item.user_id);
            formData.append('twitter', this.state.item.twitter);
            formData.append('facebook', this.state.item.facebook);
            formData.append('linkedin', this.state.item.linkedin);
            formData.append('verification', this.state.item.verification);

            createExternalWriter(formData)
            .then(response => {
                if(response.status) {
                    let temp = this.state.item;
                    temp['user_id'] = response.data.id;
                    this.setState({ item: temp});
                    saveWriter(this.state.item)
                        .then(response => {
                            this.props.reloadItem();
                            this.props.hideCreate();
                            this.setState({ loading: false });
                           
                        })
                }
            })
                .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        this.setState({ loading: false });
                        this.context.state.showCodeMessage(errors.response.data.message, 'danger');
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });
        }  
    };

    validURL(str) {
        let pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    onChange(field) {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    }

    fileChangedHandler = (event) => {
        const file = event.target.files[0]; 
        let file_name = event.target.files[0].name;
        let file_type = event.target.files[0].type;
        let file_size = event.target.files[0].size;
        this.setState({ selectedFile: file });
    }

    handleIndustrySelectChange = selectedOption => {
        let temp = this.state.item;

        temp.industry = [];
        if (selectedOption !== null && selectedOption.length > 0) {
            selectedOption.forEach(function (item, index) {
                temp.industry[index] = {};
                temp.industry[index]['id'] = item.value;
                temp.industry[index]['value'] = item.value;
                temp.industry[index]['name'] = item.name;
                temp.industry[index]['label'] = item.label;
            });
        } 
        let error = this.state.errors;
        error.industry = null;

        this.setState({ item: temp, errors: error });
    };

    handleSkillSelectChange = selectedOption => {
        let temp = this.state.item;

        temp.skill = [];
        if (selectedOption !== null && selectedOption.length > 0) {
            selectedOption.forEach(function (item, index) {
                temp.skill[index] = {};
                temp.skill[index]['id'] = item.value;
                temp.skill[index]['value'] = item.value;
                temp.skill[index]['name'] = item.name;
                temp.skill[index]['label'] = item.label;
            });
        } 
        let error = this.state.errors;
        error.skill = null;

        this.setState({ item: temp, errors: error });
    };

    handleTopicSelectChange = selectedOption => {
        let temp = this.state.item;

        temp.topic = [];
        if (selectedOption !== null && selectedOption.length > 0) {
            selectedOption.forEach(function (item, index) {
                temp.topic[index] = {};
                temp.topic[index]['id'] = item.value;
                temp.topic[index]['value'] = item.value;
                temp.topic[index]['name'] = item.name;
                temp.topic[index]['label'] = item.label;
            });
        } 
        let error = this.state.errors;
        error.topic = null;

        this.setState({ item: temp, errors: error });
    };

    handleStatusSelectChange = selectedOption => {
       
        let temp = this.state.item;
        temp['status'] = selectedOption.value;
        
        let error = this.state.errors;
        error.status = null;

        this.setState({ item: temp, errors: error });
    }

    handleClipValues = (clipValue) => {
        let temp = this.state.item;
        temp['clips'] = clipValue;

        this.setState({ item: temp });
    }

    handleLocations = (locationValue, country_code) => {
        let temp = this.state.item;
        temp['location'] = locationValue;
        temp['country_code'] = country_code;
        this.setState({ item: temp });
    }

    handleCheck = () => {
        let temp = this.state.item;
        temp['verification'] = this.state.item.verification === true ? false : true;

        this.setState({ item: temp });
    }

    handleSelectChange = selectedOption => {
       
        let temp = this.state.item;
        temp.badge = [];

        if (selectedOption !== null && selectedOption.length > 0) {
            selectedOption.forEach(function (item, index) {
                temp.badge[index] = {};                
                temp.badge[index]['id'] = item.value;
                temp.badge[index]['value'] = item.value;
                temp.badge[index]['name'] = item.name;
                temp.badge[index]['label'] = item.label;
            });
        } 
        let error = this.state.errors;
        error.badge = null;

        this.setState({ item: temp, errors: error });
    }

    handleRejectSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.reason = [];

        if (selectedOption !== null && selectedOption.length > 0) {
            selectedOption.forEach(function (item, index) {
                temp.reason[index] = {};                
                temp.reason[index]['id'] = item.value;
                temp.reason[index]['value'] = item.value;
                temp.reason[index]['name'] = item.name;
                temp.reason[index]['label'] = item.label;
            });
        } 
        let error = this.state.errors;
        error.reason = null;

        this.setState({ item: temp, errors: error });
    }


    componentDidMount() {
        
        industryList()
            .then(res => {
                this.setState({ industryList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        skillList()
            .then(res => {
                this.setState({ skillList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        jobNicheList()
            .then(res => {
                this.setState({ topicList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        badgeList()
            .then(res => {
                this.setState({ badgeList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
        rejectedReasons()
            .then(res => {
                this.setState({ rejectedReasons: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    render() {
        return (
            <div className="model-container model-center model-backdrop-show external-user-modal-container">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-5">Create record</h2>
                    <div className="model-content">
                        <form onSubmit={this.create}>
                            
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <label>First Name</label>
                                        <input
                                            onChange={this.onChange.bind(this)}
                                            type="text"
                                            className="form-control"
                                            id="first_name"
                                            name="first_name"
                                            placeholder="Enter First Name"
                                        ></input>
                                        {this.state.errors.first_name ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.first_name}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label>Last Name</label>
                                        <input
                                            onChange={this.onChange.bind(this)}
                                            type="text"
                                            className="form-control"
                                            id="last_name"
                                            name="last_name"
                                            placeholder="Enter Last Name"
                                        ></input>
                                        {this.state.errors.last_name ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.last_name}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <label>Email Address</label>
                                        <input
                                            onChange={this.onChange.bind(this)}
                                            type="text"
                                            className="form-control"
                                            id="email_address"
                                            name="email_address"
                                            placeholder="Enter Email Address"
                                        ></input>
                                        {this.state.errors.email_address ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.email_address}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label>Location</label>
                                        <SearchLocationInput value={this.state.item.location} onChange={this.handleLocations}/>
                                        
                                        {this.state.errors.location ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.location}
                                            </div>
                                        ) : null}
                                       
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <label>Industry</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                placeholder: (defaultStyles) => {
                                                    return {
                                                        ...defaultStyles,
                                                        color: "#b2c3da",
                                                        fontWeight: "500",
                                                        fontSize: "0.9 rem"
                                                    }
                                                }
                                            }}
                                            name="industry"
                                            placeholder="Select Industry"
                                            isMulti={true}

                                            // value={this.state.industryList.filter(
                                            //     item => {
                                            //         const temp = this.state.item.industry_id.map(
                                            //             item => item.industry_id
                                            //         );
                                            //         return (
                                            //             temp.indexOf(item.id) >= 0
                                            //         );
                                            //     }
                                            // )}

                                            onChange={
                                                this
                                                    .handleIndustrySelectChange
                                            }
                                            options={
                                                this.state.industryList
                                            }
                                        ></Select>
                                        {this.state.errors.industry ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.industry}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label>Topic</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                placeholder: (defaultStyles) => {
                                                    return {
                                                        ...defaultStyles,
                                                        color: "#b2c3da",
                                                        fontWeight: "500",
                                                        fontSize: "0.9 rem"
                                                    }
                                                }
                                            }}
                                            name="topic"
                                            placeholder="Select Topic"
                                            isMulti={true}
                                            // value={this.state.jobNicheList.filter(
                                            //     item => {
                                            //         const temp = this.state.item.jobNiche_id.map(
                                            //             item => item.topic_id
                                            //         );
                                            //         return (
                                            //             temp.indexOf(item.id) >= 0
                                            //         );
                                            //     }
                                            // )}
                                            onChange={
                                                this
                                                    .handleTopicSelectChange
                                            }
                                            options={
                                                this.state.topicList
                                            }
                                        ></Select>
                                        {this.state.errors.topic ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.topic}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <label>Skill</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                placeholder: (defaultStyles) => {
                                                    return {
                                                        ...defaultStyles,
                                                        color: "#b2c3da",
                                                        fontWeight: "500",
                                                        fontSize: "0.9 rem"
                                                    }
                                                }
                                            }}
                                            name="skill"
                                            id="skill"
                                            isMulti={true}
                                            placeholder="Select Skill"
                                            onChange={
                                                this
                                                    .handleSkillSelectChange
                                            }
                                            options={
                                                this.state.skillList
                                            }
                                            // value={this.state.skillList.filter(
                                            //     item => {
                                            //         const temp = this.state.item.skill_id.map(
                                            //             item => item.skill_id
                                            //         );
                                            //         return (
                                            //             temp.indexOf(item.id) >= 0
                                            //         );
                                            //     }
                                            // )}
                                        ></Select>
                                        {this.state.errors.skill ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.skill}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label>Personal Website</label>
                                        <input
                                            onChange={this.onChange.bind(this)}
                                            type="text"
                                            className="form-control"
                                            id="personalWebsite"
                                            name="personalWebsite"
                                            placeholder="Enter Personal Website URL"
                                        ></input>
                                        {this.state.errors.personalWebsite ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.personalWebsite}
                                            </div>
                                        ) : null}

                                    </div>
                                </div>
                            </div>


                            <div className="form-group">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <label>Verification Status</label>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    "&:hover": {
                                                        borderColor:
                                                            "#1cd2ad",
                                                        boxShadow: "none"
                                                    },
                                                    "&": {
                                                        borderColor:
                                                            "#d2ddec",
                                                        boxShadow: "none"
                                                    }
                                                }),
                                                dropdownIndicator: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                singleValue: base => ({
                                                    ...base,
                                                    color: "inherit"
                                                }),
                                                placeholder: (defaultStyles) => {
                                                    return {
                                                        ...defaultStyles,
                                                        color: "#b2c3da",
                                                        fontWeight: "500",
                                                        fontSize: "0.9 rem"
                                                    }
                                                }
                                            }}
                                            name="status"
                                            onChange={this.handleStatusSelectChange}
                                            id="status"
                                            placeholder="Select Verification Status"
                                            options={
                                                this.state.statusList
                                            }
                                        >
                                        </Select>
                                        {this.state.errors.status ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.status}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        {this.state.item.status !== "rejected" &&
                                            <div>
                                                <label>Badge</label>
                                                <Select
                                                    styles={{
                                                        control: base => ({
                                                            ...base,
                                                            "&:hover": {
                                                                borderColor: "#1cd2ad",
                                                                boxShadow: "none"
                                                            },
                                                            "&": {
                                                                borderColor: "#d2ddec",
                                                                boxShadow: "none"
                                                            }
                                                        }),
                                                        dropdownIndicator: base => ({
                                                            ...base,
                                                            color: "inherit"
                                                        }),
                                                        singleValue: base => ({
                                                            ...base,
                                                            color: "inherit"
                                                        }),
                                                        placeholder: (defaultStyles) => {
                                                            return {
                                                                ...defaultStyles,
                                                                color: "#b2c3da",
                                                                fontWeight: "500",
                                                                fontSize: "0.9 rem"
                                                            }
                                                        }
                                                    }}
                                                    isMulti={true}
                                                    name="badges"
                                                    className="select2"
                                                    // value={this.state.badges.filter(
                                                    //     item => {
                                                    //         const temp = this.state.item.user_badges.map(
                                                    //             item => item.badge_id
                                                    //         );
                                                    //         return (
                                                    //             temp.indexOf(item.id) >= 0
                                                    //         );
                                                    //     }
                                                    // )}
                                                    placeholder="Select Badge"
                                                    onChange={this.handleSelectChange}
                                                    options={this.state.badgeList}
                                                ></Select>
                                            </div>
                                        }


                                        {this.state.item.status == "rejected" &&
                                            <div>
                                                <label>Reason</label>
                                                <Select
                                                    styles={{
                                                        control: base => ({
                                                            ...base,
                                                            "&:hover": {
                                                                borderColor: "#1cd2ad",
                                                                boxShadow: "none"
                                                            },
                                                            "&": {
                                                                borderColor: "#d2ddec",
                                                                boxShadow: "none"
                                                            }
                                                        }),
                                                        dropdownIndicator: base => ({
                                                            ...base,
                                                            color: "inherit"
                                                        }),
                                                        singleValue: base => ({
                                                            ...base,
                                                            color: "inherit"
                                                        }),
                                                        placeholder: (defaultStyles) => {
                                                            return {
                                                                ...defaultStyles,
                                                                color: "#b2c3da",
                                                                fontWeight: "500",
                                                                fontSize: "0.9 rem"
                                                            }
                                                        }
                                                    }}
                                                    isMulti={true}
                                                    name="reason"
                                                    className="select2"
                                                    placeholder="Select Reasons"
                                                    onChange={
                                                        this.handleRejectSelectChange
                                                    }
                                                    options={this.state.rejectedReasons}
                                                ></Select>

                                                {this.state.errors.reason ? (
                                                    <div className="text-danger">
                                                        {this.state.errors.reason}
                                                    </div>
                                                ) : null}
                                            
                                            </div>
                                        }

                                    </div>
                                </div>
                            </div>
                            
                            {this.state.item.status === "rejected" && 
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-12 col-md-12">
                                            <label>Decline Details</label>
                                            <textarea
                                                onChange={this.onChange.bind(this)}
                                                className="form-control"
                                                value={this.state.item.decline_details}
                                                placeholder="Decline details"
                                                name="decline_details"
                                                rows="3"
                                            ></textarea>
                                            {this.state.errors.decline_details ? (
                                                <div className="invalid-feedback">
                                                    {this.state.errors.decline_details}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>    
                                </div>                
                            }
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-12 col-md-12">
                                        <label>ByLine</label>
                                        <textarea
                                            onChange={this.onChange.bind(this)}
                                            name="byLine"
                                            id="byLine"
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter byLine">
                                        </textarea>
                                        {this.state.errors.byLine ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.byLine}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>    

                            <div className="form-group">
                                <div className="row">
                                    <div className="col-12 col-md-12">
                                        <label className="mb-1">
                                            Profile picture
                                        </label>
                                        <small className="form-text text-muted">
                                            <input
                                                id="writer_image"
                                                name="writer_image"
                                                onChange={this.fileChangedHandler}
                                                type="file"
                                                className="form-control"
                                            />

                                            {this.state.errors.writer_image ? (
                                                <div className="text-danger">
                                                    {this.state.errors.writer_image}
                                                </div>
                                            ) : null}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <AddClip onChange={this.handleClipValues}/>
                            {this.state.errors.clips ? (
                                <div className="invalid-feedback">
                                    {this.state.errors.clips}
                                </div>
                            ) : null}

                            <div className="form-group">
                                <div className="row">
                                    <div className="col-12 col-md-12">
                                        <label>
                                            Social profile links
                                        </label>
                                        <div className="form-group m-form__group">
                                            <div className="row">
                                                <div className="col-12 col-md-10 pl-0">
                                                    <div className="input-group">
                                                        <span className="input-group-addon" id="basic-addon1">
                                                            <i className="fab fa-twitter"></i>
                                                        </span>
                                                        <input placeholder="JohnSmith" name="twitter" onChange={this.onChange.bind(this)} type="text" className="form-control-prepended form-control"></input>
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">
                                                                Twitter.com/
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group">
                                            <div className="row">
                                                <div className="col-12 col-md-10 pl-0">
                                                    <div className="input-group">
                                                        <span className="input-group-addon" id="basic-addon1">
                                                            <i className="fab fa-facebook"></i>
                                                        </span>
                                                        <input placeholder="John.Smith" name="facebook" onChange={this.onChange.bind(this)} type="text" className="form-control-prepended form-control"></input>
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">
                                                                Facebook.com/
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group">
                                            <div className="row">
                                                <div className="col-12 col-md-10 pl-0">
                                                    <div className="input-group">
                                                        <span className="input-group-addon" id="basic-addon1">
                                                            <i className="fab fa-linkedin"></i>
                                                        </span>
                                                        <input placeholder="John-Smith" name="linkedin" onChange={this.onChange.bind(this)} type="text" className="form-control-prepended form-control"></input>
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">
                                                                Linkedin.com/in/
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>        
                            <div className="form-group">
                                <input
                                    // checked={this.state.showCertiDiv}
                                    onChange={this.handleCheck}
                                    className="react-switch-checkbox"
                                    type="checkbox"
                                    name="verification"
                                />
                                <label htmlFor="verification" className="ml-4 mr-2">Verified?</label>
                            </div>
                            <div className="form-group">
                                <button
                                    type="submit"
                                    className="btn btn-primary mr-2"
                                    disabled={this.state.loading}
                                >
                                    {this.state.loading ? `Processing...` : `Submit`}
                                    <i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : ``}></i>
                                </button>
                                <button
                                    type="button"
                                    onClick={this.props.hideCreate}
                                    className="btn btn-default"
                                    disabled={this.state.loading}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
CreateModel.contextType = AppContext;
export default CreateModel;



// WEBPACK FOOTER //
// ./src/components/admin/writers/CreateModel.js